/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

export interface TestUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  organizationId: string;
}

export interface DefaultTestUsers {
  owner: TestUser;
  admin: TestUser;
  member: TestUser;
  [key: string]: TestUser;
}

const EMPTY_USER: TestUser = {
  id: "",
  email: "",
  firstName: "",
  lastName: "",
  role: "",
  organizationId: "",
};

export const DEFAULT_TEST_USERS: DefaultTestUsers =
  process.env.NODE_ENV === "production"
    ? { owner: EMPTY_USER, admin: EMPTY_USER, member: EMPTY_USER }
    : {
        owner: {
          id: "410c444d-cab9-49c7-bd56-0dd125d4bb24",
          email: "owner@test.com",
          firstName: "Test",
          lastName: "Owner",
          role: "owner",
          organizationId: "550e8400-e29b-41d4-a716-446655440001",
        },
        admin: {
          id: "520c444d-cab9-49c7-bd56-0dd125d4bb25",
          email: "admin@test.com",
          firstName: "Test",
          lastName: "Admin",
          role: "admin",
          organizationId: "550e8400-e29b-41d4-a716-446655440001",
        },
        member: {
          id: "630c444d-cab9-49c7-bd56-0dd125d4bb26",
          email: "member@test.com",
          firstName: "Test",
          lastName: "Member",
          role: "member",
          organizationId: "550e8400-e29b-41d4-a716-446655440001",
        },
      };

export function getTestUser(
  role: keyof typeof DEFAULT_TEST_USERS = "owner",
): TestUser {
  const user = DEFAULT_TEST_USERS[role];
  if (!user) {
    throw new Error(`Test user with role ${role} not found`);
  }
  return user;
}
